import React, {useContext} from "react";
import "./App.css";
import {Navigate, Route, Routes} from "react-router";
import {LandingPage} from "./views/LandingPage";
import {useLocation} from "react-router-dom";
import Imprint from "./views/Imprint";
import AuthErrorPage from "./views/AuthErrorPage";
import {KeycloakContext} from "./views/utility/KeycloakProvider";

function App() {
  const {keycloak, initialized, authenticated} = useContext(KeycloakContext);
  const pathname = useLocation().pathname;

  if (pathname == "/imprint") return <Imprint />;

  if (!initialized || !authenticated)
    return <AuthErrorPage reason="unauthenticated" />;

  if (!keycloak.hasResourceRole("DV Mitglied"))
    return <AuthErrorPage reason="unauthorized" />;

  return (
    <Routes>
      <Route path="/*" element={<LandingPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
